@let w = workerDisplay();

@if (isSimple()) {
  <div>
    @if (withNameLabel()) {
      <div class="w-h-label html-overflow">
        {{ nameLabel() | translate }}
      </div>
    }
    <div class="html-overflow default-value">
      {{ w?.name }}
    </div>
  </div>
}

@if (!isSimple() && !withDetailPageNav() && !isAvatar()) {
  <div>
    @if (withNameLabel()) {
      <div class="w-h-label html-overflow">
        {{ nameLabel() | translate }}
      </div>
    }
    <div class="worker-chip">
      <div>
        @if (w) {
          <app-w-h-chip-list
            [data]="[w]"
            [imageKey]="'smallerAvatarURL'"
            [tooltipKeys]="[w?.extId ? 'extId' : '', w?.name ? 'name' : '']"
            [isRemoveButtonVisible]="isRemoveable()"
            [titleKey]="'name'"
            [isStacked]="false"
            [placeholderImg]="personImgJPG"
            (handleRemoveChip)="removeChip()"
          ></app-w-h-chip-list>
        }
      </div>
    </div>
  </div>
}

@if (!isSimple() && withDetailPageNav() && !isAvatar()) {
  <div>
    @if (withNameLabel()) {
      <div class="w-h-label html-overflow">
        {{ nameLabel() | translate | uppercase }}
      </div>
    }
    <div class="worker-chip">
      <div>
        @if (w) {
          <app-w-h-chip-list
            [data]="[w]"
            [imageKey]="'smallerAvatarURL'"
            [navigateToKey]="w?.workerDetailRouterLink ? 'workerDetailRouterLink' : null"
            [tooltipKeys]="[w?.extId ? 'extId' : '', w?.name ? 'name' : '']"
            [isRemoveButtonVisible]="isRemoveable()"
            [titleKey]="'name'"
            [placeholderImg]="personImgJPG"
            (handleRemoveChip)="removeChip()"
          ></app-w-h-chip-list>
        }
      </div>
    </div>
  </div>
}

@if (!isSimple() && !withDetailPageNav() && isAvatar()) {
  <span style="display: flex; align-self: center">
    @if (
      w?.smallerAvatarURL &&
        (w?.smallerAvatarURL | WHImgAuthHeader: personImgJPG | async);
      as image
    ) {
      <img
        alt="logoSmall"
        [src]="image"
        mat-card-avatar
        class="small-avatar"
        matTooltip="{{ (w?.extId ? w?.extId : '') + ' ' + w?.name }}"
      />
    } @else {
      <img
        [src]="personImgJPG"
        mat-card-avatar
        alt="personImg"
        class="small-avatar"
        matTooltip="{{ (w?.extId ? w?.extId : '') + ' ' + w?.name }}"
      />
    }
  </span>
}
